import moment from 'moment'

const dateUtils = {

  parse (dateString, dateFormat) {
    return moment(dateString, dateFormat);
  },

  lbl_date_today () {
    return moment().format('DD.MM.YYYY')
  },

  lbl_date_yesterday () {
    return moment().subtract(1, 'days').format('DD.MM.YYYY')
  },

  lbl_date_this_week () {
    return moment().week()
  },

  lbl_date_last_week () {
    return moment().subtract(1, 'weeks').week()
  },

  lbl_date_this_month () {
    return moment().format('MMMM YYYY')
  },

  lbl_date_last_month () {
    return moment().subtract(1, 'months').format('MMMM YYYY')
  },

  lbl_date_this_year () {
    return moment().format('YYYY')
  },

  lbl_date_last_year () {
    return moment().subtract(1, 'years').format('YYYY')
  },

  val_date_today () {
    return {
      start: moment(),
      end: moment()
    }
  },

  val_date_yesterday () {
    return {
      start: moment().subtract(1, 'days'),
      end: moment().subtract(1, 'days')
    }
  },

  val_date_this_week () {
    return {
      start: moment().startOf('week'),
      end: moment().endOf('week')
    }
  },

  val_date_last_week () {
    return {
      start: moment().subtract(1, 'week').startOf('week'),
      end: moment().subtract(1, 'week').endOf('week')
    }
  },

  val_date_this_month () {
    return {
      start: moment().startOf('month'),
      end: moment().endOf('month')
    }
  },

  val_date_last_month () {
    return {
      start: moment().subtract(1, 'months').startOf('month'),
      end: moment().subtract(1, 'months').endOf('month')
    }
  },

  val_date_this_quarter () {
    return {
      start: moment().startOf('quarter'),
      end: moment().endOf('quarter')
    }
  },

  val_date_last_quarter () {
    return {
      start: moment().subtract(1, 'quarters').startOf('quarter'),
      end: moment().subtract(1, 'quarters').endOf('quarter')
    }
  },

  val_date_this_year () {
    return {
      start: moment().startOf('year'),
      end: moment().endOf('year')
    }
  },

  val_date_last_year () {
    return {
      start: moment().subtract(1, 'years').startOf('year'),
      end: moment().subtract(1, 'years').endOf('year')
    }
  },

  getWeekRange (year, week) {
    return {
      start: moment(year, "YYYY").week(week).startOf('week'),
      end: moment(year, "YYYY").week(week).endOf('week')
    }
  },

  getMonthRange (year, month) {
    return {
      start: moment(year, "YYYY").month(month - 1).startOf('month'),
      end: moment(year, "YYYY").month(month - 1).endOf('month'),
      label: moment(year, "YYYY").month(month - 1).format('MMMM')
    }
  },

  getQuarterRange (year, quarter) {
    return {
      start: moment(year, "YYYY").quarter(quarter).startOf('quarter'),
      end: moment(year, "YYYY").quarter(quarter).endOf('quarter')
    }
  },

  getYearRange (year) {
    return {
      start: moment(year, "YYYY").startOf('year'),
      end: moment(year, "YYYY").endOf('year')
    }
  },

  getCurrentWeek () {
    return moment().week()
  },

  getCurrentMonth () {
    return moment().month()
  },

  getCurrentQuarter () {
    return moment().quarter()
  },

  getCurrentYear () {
    return moment().year()
  },

  getDayDiff (date1, date2, format, group) {
    const date1Moment = moment(date1, format)
    const date2Moment = moment(date2, format)
    return Math.abs(date1Moment.diff(date2Moment, group))
  },

  getMonthList () {
    return moment.months().map((month, index) => ({
      id: index,
      name: month
    }))
  },

  getYearList () {
    const currentYear = dateUtils.getCurrentYear()
    return [
      currentYear + 1,
      currentYear,
      currentYear - 1,
      currentYear - 2,
      currentYear - 3,
      currentYear - 4,
      currentYear - 5
    ].map((year, index) => ({
      id: year,
      name: year
    }))
  },

  getLastNWeeks (count) {
    let weekList = []
    for (let i = 0; i < count; i++) {
      weekList.unshift([
        moment().subtract(i, 'week').startOf('week'),
        moment().subtract(i, 'week').endOf('week')
      ])
    }

    return weekList
  },

  getLastNMonths (count) {
    let monthList = []
    for (let i = 0; i < count; i++) {
      monthList.unshift([
        moment().subtract(i, 'month').startOf('month'),
        moment().subtract(i, 'month').endOf('month')
      ])
    }

    return monthList
  }

}

export function mapDateUtils (functionNames) {
  let result = {};
  functionNames.forEach(functionName => {
    result[functionName] = dateUtils[functionName]
  });
  return result;
}
